import React from 'react';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import FreelancerPaymentExportService from '../../../Services/FreelancerPaymentExportService';
import FreelancerPaymentExportSearchParams from './FreelancerPaymentExportSearchParams';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FreelancerPaymentExportItem from '../../../Domain/FreelancerPaymentExportItem';
import fileHelper from '../../../Helpers/fileHelper';
import AttachmentService from '../../../Services/AttachmentService';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import UserService from '../../../Services/userService';
import AuthService from '../../../Services/authService';

class FreelancerPaymentExportAdmin extends React.Component {
  static defaultProps = {
    searchItem: null,
  };

  constructor(props) {
    super(props);
    let searchItem = new FreelancerPaymentExportSearchParams();
    if (props.searchItem) {
      searchItem = props.searchItem;
    }

    this.state = {
      itemList: [],
      orderDirection: OrderDirectionsEnum.Desc,
      shownPanel: ShownPanelsEnum.Search,
      searchItem: searchItem,
    };
    this.startSearch = this.startSearch.bind(this);
    FreelancerPaymentExportItem.clickOnGeneratePaymentExportFileIcon =
      this.clickOnGeneratePaymentExportFileIcon.bind(this);
    FreelancerPaymentExportItem.clickOnDownloadFile = this.clickOnDownloadFile.bind(this);
  }

  clickOnDownloadFile(item) {
    AttachmentService.DownloadAttachmentFile(item.AttachmentId)
      .then((result) => {
        fileHelper.saveBase64File(result, item.FileName, item.ContentType);
      })
      .catch((error) => ErrorMessage.SetErrorMessage('AC144'));
  }

  clickOnGeneratePaymentExportFileIcon(item) {
    FreelancerPaymentExportService.GeneratePaymentExportFile(item.FreelancerPaymentExportId)
      .then((result) => {
        this.refresh();
        ErrorMessage.SetNotification(
          'The payment export file has been created. You can download it from the Vendor Payment Export page.'
        );
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: FPEA144');
      });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  startSearch(searchItem) {
    if (
      AuthService.HasRoleArray(['FinanceAdmin_VendorMgtm', 'VendorInvoicingAdmin_*']) &&
      !AuthService.IsAdmin() &&
      !searchItem?.OfficeId
    ) {
      searchItem = { ...searchItem, OfficeId: UserService.GetOfficeIdOfLoggedInUser() };
    }
    this.setState({
      searchItem,
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={FreelancerPaymentExportItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={FreelancerPaymentExportService.GetFreelancerPaymentExportList}
          convertDBItemsFunction={FreelancerPaymentExportService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={FreelancerPaymentExportSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          errorCode='FPEA101'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search for id, office, payment method or creator...'
        />
      </div>
    );
  }
}

export default FreelancerPaymentExportAdmin;
